import { FormValueObject, WizardStepChangeEventHandler } from 'components/types'
import { Location } from 'newTypes/location'
import { ChangeEvent, useState } from 'react'
import { FieldChangeEventAnswer } from 'types/general'

interface BooleanFormValue {
  name: string
}
const useWizardForm = () => {
  const [formValues, setFormValues] = useState({})

  const updateFormValue = (
    data: WizardStepChangeEventHandler | ChangeEvent<HTMLInputElement> | FieldChangeEventAnswer | Location
  ) => {
    if ('target' in data) {
      const { name, value } = data.target
      return setFormValues(formValues => ({
        ...formValues,
        [name]: value,
      }))
    }
    
    if (!('name' in data && 'value' in data)) {
      return
    }

    const { name, type, value } = data as WizardStepChangeEventHandler
    return setFormValues(formValues => {
      if (type === 'parentCheckbox') {
        const currentValues = formValues as FormValueObject
        const currentCheckedValues = value as unknown as BooleanFormValue

        return {
          ...currentValues,
          [name]: {
            ...currentValues[name],
            [currentCheckedValues.name]: currentCheckedValues,
          },
        }
      }

      if (name === 'images' && value) {
        return {
          ...formValues,
          [name]: value,
        }
      }

      if (name === 'location' && value) {
        return {
          ...formValues,
          [name]: value,
        }
      }

      const newValue = value !== undefined ? String(value) : ''

      return {
        ...formValues,
        [name]: newValue,
      }
    })
  }
  return {
    formValues,
    setFormValues,
    updateFormValue,
  }
}

export default useWizardForm
